import { createTheme, responsiveFontSizes } from "@mui/material/styles";

export const tokens = {
  navy: {
    100: "#c7d0e8",
    200: "#8fa0cc",
    300: "#5770b0",
    400: "#3a5494",
    500: "#1f2a5a",
    600: "#192248",
    700: "#131936",
    800: "#0c1124",
    900: "#060812",
  },
  red: {
    100: "#fce8e9",
    200: "#f4b4b7",
    300: "#e87c80",
    400: "#CC2229",   // brand red - matches logo J
    500: "#a81b21",
    600: "#8b1219",
    700: "#6e0d12",
    800: "#520a0d",
    900: "#350407",
  },
  grey: {
    100: "#e6e6e6",
    200: "#cccccc",
    300: "#b3b3b3",
    400: "#999999",
    500: "#808080",
    600: "#666666",
    700: "#4d4d4d",
    800: "#333333",
    900: "#1a1a1a",
  },
};

const baseTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: tokens.red[400],       // #CC2229 - brand red
      light: tokens.red[300],      // #e87c80
      dark: tokens.red[500],       // #a81b21
    },
    secondary: {
      main: tokens.red[500],
      dark: tokens.red[600],
    },
    background: {
      default: tokens.navy[500],   // #1f2a5a - navy page background
      paper: "#162347",            // deeper navy for cards/surfaces
    },
    text: {
      primary: "#ffffff",
      secondary: "#cbd5e1",
    },
    error: {
      main: "#ef4444",
    },
    divider: "rgba(255,255,255,0.1)",
  },
  typography: {
    fontFamily: "'Montserrat', sans-serif",
    fontSize: 16,
    h1: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 56,
      fontWeight: 800,
      lineHeight: 1.1,
      letterSpacing: 0.5,
    },
    h2: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 44,
      fontWeight: 700,
      lineHeight: 1.15,
    },
    h3: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 34,
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h4: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 26,
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h5: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 20,
      fontWeight: 600,
    },
    h6: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 17,
      fontWeight: 600,
    },
    subtitle1: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 18,
      lineHeight: 1.5,
    },
    subtitle2: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 16,
      fontWeight: 500,
    },
    body1: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 16,
      lineHeight: 1.7,
    },
    body2: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 14,
      lineHeight: 1.6,
    },
    caption: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: 12,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontFamily: "'Montserrat', sans-serif",
          fontWeight: 600,
          minHeight: 44,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "'Montserrat', sans-serif",
        },
      },
    },
  },
});

export const theme = responsiveFontSizes(baseTheme, { factor: 2.5 });
